import React, { useState, useCallback, useRef, useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
//api
import { createBlogCategory } from 'api/blog';
//components
import Title from 'components/backoffice/texts/title';
import CategoryForm from 'components/backoffice/forms/categoryForm';

const category = {
  image: undefined,
  name: '',
};

const CreateBlogCategory = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(['backoffice']);
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [validateName, setValidateName] = useState('');
  const { setTitle } = useOutletContext()

  const onSubmit = useCallback(async (values) => {
    setLoading(true)
    const categories = {
      name: values.name,
      image: values.image,
    };

    try {
      const response = await createBlogCategory(categories);
      if (response?.status === 201) {
        toast.success(t('creadocorrectamente'));
        navigate('/intranet/blog-categories', { replace: true });
      } else if (response?.status === 400) {
        setValidateName(response.data.name[0])
      }
      else {
        toast.error(`${t('error')} ${response?.status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false)
  }, []);

  useEffect(() => {
    setTitle(t('createblogcategory'))
    return () => {
      setTitle('');
    };
  }, [setTitle])

  return (
    <div className="mt-5">
      <Title text={t('createblogcategory')} />
      <CategoryForm
        loading={loading}
        isEditing={false}
        onSubmitForm={onSubmit}
        defaultValues={category}
        fileInputRef={fileInputRef}
        validateName={validateName}
        setValidateName={setValidateName}
      />
    </div>
  );
};

export default CreateBlogCategory;
